import React from "react";
import Form, {
  SimpleItem,
  GroupItem,
  RequiredRule,
  ButtonItem,
} from "devextreme-react/form";

const reportTypes = ["Sales", "Purchase"];

const buttonOptions = {
  useSubmitBehavior: true,
  stylingMode: "contained",
  type: "default",
  text: "Get report",
  elementAttr: { style: "background-color: #0737a0" },
};

const ReportSelector = ({ formData, handleSubmit }) => {
  return (
    <div className="mt-4">
      <div className="report-selector">
        <form onSubmit={handleSubmit}>
          <Form labelLocation="top" formData={formData}>
            <GroupItem colSpan={1}>
              <SimpleItem
                dataField="reportType"
                editorType="dxSelectBox"
                editorOptions={{
                  showClearButton: true,
                  items: reportTypes,
                  placeholder: "Select a report type",
                }}
              >
                <RequiredRule message="Report type is required" />
              </SimpleItem>
            </GroupItem>
            <GroupItem colCount={2}>
              <SimpleItem
                dataField="startDate"
                editorType="dxDateBox"
                editorOptions={{
                  type: "date",
                  showClearButton: true,
                  pickerType: "calender",
                  displayFormat: "EEEE dd, MMM, yyyy ",
                }}
              >
                <RequiredRule message="Start date is required" />
              </SimpleItem>
              <SimpleItem
                dataField="endDate"
                editorType="dxDateBox"
                editorOptions={{
                  type: "date",
                  pickerType: "calender",
                  showClearButton: true,
                  displayFormat: "EEEE dd, MMM, yyyy ",
                }}
              >
                <RequiredRule message="End date is required" />
              </SimpleItem>
            </GroupItem>
            <ButtonItem
              horizontalAlignment="left"
              buttonOptions={buttonOptions}
            />
          </Form>
        </form>
      </div>
    </div>
  );
};

export default ReportSelector;
